export const getUnitSelected = state => state.unitSelected.data
